import './ccf-phone-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';
/* eslint-disable-next-line */
export interface CcfPhoneIconProps extends SvgIconProps {}

/**
 *
 * @param props - CcfPhoneIconProps
 * @example
 * @returns
 */
export function CcfPhoneIcon(props: CcfPhoneIconProps) {
  return (
    <SvgIcon {...props}>
      <g id="phone-outbound" transform="translate(0.502 0.463)">
        <path
          id="Path_12422"
          data-name="Path 12422"
          d="M13.289-28.627s-.875,1.413-.956,1.533-.25.475-1.065.235c-.894-.264-2.432-1.008-4.826-3.48S3.329-34.4,3.074-35.325c-.233-.842.111-1.017.227-1.1s1.484-.987,1.484-.987c.92-.558-.12-2.943-1.8-4.09-1.24-.847-1.784-.765-2.3-.348a13.411,13.411,0,0,0-2.26,2.393,2.332,2.332,0,0,0-.4,1.633A13.949,13.949,0,0,0-.126-32.687a24.582,24.582,0,0,0,3.892,5.114,24.093,24.093,0,0,0,4.95,4.021,12.938,12.938,0,0,0,4.972,1.909,2.155,2.155,0,0,0,1.581-.408,13.382,13.382,0,0,0,2.317-2.335c.4-.538.483-1.1-.337-2.381C16.137-28.5,13.829-29.577,13.289-28.627Z"
          transform="translate(2 42.156)"
          fill="#0d3970"
          stroke="rgba(0,0,0,0)"
          strokeMiterlimit="10"
          strokeWidth="1"
        />
      </g>
    </SvgIcon>
  );
}

export default CcfPhoneIcon;
